<div class="create-or-edit-collection-page-container container" fxLayout="column" fxLayoutGap="15px">
  <div *ngIf="wizard.model.storeUuids?.length" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
    <fa-icon class="color-help" icon="info-circle" size="2x"></fa-icon>
    <span>{{ 'createOrEditCollection.store_info' | translate:{count: wizard.model.storeUuids.length, storeLabel: wizard.model.storeUuids.length === 1 ? 'store' : 'stores'} }}</span>
  </div>
  <div fxLayout="column" [formGroup]="form">
    <mtn-text-field [form]="form" controlName="name" placeholder="{{ 'createOrEditCollection.name_placeholder' | translate }}" [isRequired]="true"></mtn-text-field>
    <mtn-text-area-field [form]="form" controlName="description" placeholder="{{ 'createOrEditCollection.description_placeholder' | translate }}"></mtn-text-area-field>
    <mat-checkbox color="primary" formControlName="favorite" *ngIf="!wizard.model.collection?.uuid">
      {{ 'createOrEditCollection.favorite' | translate }}
    </mat-checkbox>
  </div>
</div>
